<template>
  <div class="bg-white md__card--holder">
    <div class="card border-0">
      <!-- Card header -->
      <div class="card-header bg-navy rounded-0 navbar-height d-flex align-items-center ">
        <!-- Title -->
       
        <div
          :contenteditable="canEdit"
          @keypress.enter.prevent="onTitleChanged($event)"
          @blur="onTitleChanged($event)"
          class="task-title h4 mb-0"
          v-html="editTitle"
          @focus="_onTitleFocusClicked"></div>
        <!-- <div  class="col-md-2">

          <span class="brace">{</span>
        </div> -->
     
       
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <form class="hideBlockParent">
          <!-- <div class="form-group mb-4">
            <label>Title</label>
            <input
              id="exampleFormControlInput1"
              type="text"
              class="form-control"
              v-model="project.name"
              placeholder="Title"
            />
          </div> -->
          <UserPickerProject
            v-model="project.user_owner"
            :multi="false"
            title="Project Owner"
            role="OWNER"
            @userSelected="handleSubmit"
            @userRemoved="handleSubmit"
          />

          <!-- <UserPicker v-model="project.user_assigned" :multi="false" title="Assigned To" role="VIEWER"/> -->
          <div class="row mt-4">
            <div :class="{'col-md-12':!editId, 'col-md-6':editId}">
              <base-button
                type="primary"
                class="btn-block"
                @click="handleSubmit"
                >{{ editId ? "Update" : "Create" }}</base-button
              >
            </div>
            <div class="col-md-6" v-if="editId">
              <base-button
                type="danger"
                class="btn-block"
                @click="_onArchiveClicked"
                >{{ project.is_archieved?"UnArchive":"Archive" }}</base-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import UserPickerProject from "@/app/components/UserPickerProject.vue";
import swal from "sweetalert2";

export default {
  name: "CreateAssetProject",
  props: ["editId", "data", "profile", "showSideBar"],
  data() {
    return {
      project: {
        user_owner: {},
        users: []
      },
      editTitle: "Unnamed Project"
    };
  },
  components: {
    UserPickerProject
  },
  validations: {
    projectTitle: {
      required,
      minLength: minLength(4)
    },
    projectType: {
      required
    },
    client: {
      required
    }
  },

  watch: {
    
    editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };

      if (newVal != oldVal) {
        if (newVal) {
          //this.editTitle = "Edit Project"
          this.fetchProject(newVal);
        } else {
          this.project = { user_owner: owner, asset_users: [owner] };
          this.editTitle = "Unnamed Project";
        }
      } else {
        this.project = { user_owner: owner, asset_users: [owner] };
        this.editTitle = "Unnamed Project";
      }
    },

    data(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };

      if (newVal != oldVal) {
        if (newVal) {
          //this.editTitle = "Edit Project"
          this.fetchProject(newVal.id);
        } else {
          this.project = { user_owner: owner, asset_users: [owner] };
          this.editTitle = "Unnamed Project";
        }
      } else {
        this.project = { user_owner: owner, asset_users: [owner] };
        this.editTitle = "Unnamed Project";
      }
    },
    showSideBar() {
       let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };
      this.project = { user_owner: owner, asset_users: [owner] };
    }
  },

  computed: {
    // ...mapState("user", ["profile"]),
    ...mapState("common", ["roles"]),

    canEdit() {
      if (this.project.id)
        return (
          this.project &&
          this.project.permission &&
          this.project.permission.edit == 1
        );
      else return true;
    }
  },

  async mounted() {
    console.log("mounted+++++++");
    $('[data-toggle="tooltip"]').tooltipster({
      theme: "tooltipster-borderless"
    });
    await this.fetchRoles();
    if (!this.data || this.data == null) {
      this.editTitle = "Unnamed Project";
      console.log(this.profile, 'mountedd')
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };
      this.project = { user_owner: owner };
    } else {
      this.editTitle = "Edit Project";
      this.fetchProject(this.data.id);
    }
  },

  methods: {
    ...mapActions("project", [
      "createProject",
      "updateProject",
      "fetchSingleProject",
      "updateProjectArchieveStatus"
    ]),
    ...mapActions("common", ["fetchRoles"]),
    ...mapMutations(["setGanttRender"]),

    _onTitleFocusClicked() {
      if(this.editTitle == "Unnamed Project") {
        this.editTitle = ""
      }
      
    },

    async onTitleChanged(event) {
      this.editTitle = event.target.innerHTML;
      let existingTitle = this.project.name;
      if(this.editTitle == "") {
        event.target.innerHTML = "Unnamed Project"
        this.editTitle = "Unnamed Project"
      }

      if (
        this.project &&
        this.project.permission &&
        this.project.permission.edit == 0
      )
        return false;
      if (event.target.innerHTML.length < 5) {
        swal({
          title:
            "Are you sure you want to change the name of this project from " +
            existingTitle +
            " to " +
            event.target.innerHTML +
            "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, change it!",
          buttonsStyling: false
        }).then(async result => {
          if (result.value) {
            this.project.name = this.editTitle;
            if (existingTitle != this.project.name && this.project.id)
               await this.handleSubmit();
            return false;
          } else {
            this.editTitle = existingTitle;
            return false;
          }
        });
        return false;
      } else if (event.target.innerHTML.length > 50) {
        swal({
          title: "Task title is too Long",
          type: "warning",
          // showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "OK",
          buttonsStyling: false
        }).then(result => {});
        return false;
      } else {
        this.project.name = this.editTitle;
        //alert(this.project.id)
        if (existingTitle != this.project.name && this.project.id != null)
          await this.handleSubmit();
        return false;
      }
    },

    async fetchProject(val) {
      try {
        const res = await this.fetchSingleProject(val);
        this.project = res.data;
        this.editTitle = this.project.name;
      } catch (e) {
        this.$snack.success("Could not fetch project");
      }
    },

    _onArchiveClicked () {
      swal({
          title:
            "Are you sure you want to change archive status of this project?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, change it!",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {

            let body = {
              is_archieved: this.project.is_archieved == 0?1:0
            };

            if (this.editId != undefined || this.editId != null) {
              body.id = this.data.id;
              this.updateProjectArchieveStatus(body)
                .then(res => {
                  this.setGanttRender();
                  this.$snack.success("Project Archive Status Changed Successfully");
                  this.$emit("projectCreated");
                })
                .catch(er => {
                  this.$snack.success("Could not archive project");
                });
            }
           
            return false;
          } else {
           
            return false;
          }
        });
    },

    handleSubmit() {
      if (this.project.name == null || this.project.name == "") {
        this.$snack.success("Project title is required");
        return;
      }

      
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let createor = { user: this.profile, asset_role: role };

      let body = {
        ...this.project,
        asset_users: [this.project.user_owner, createor]
      };

      if (this.data) {
        body.id = this.data.id;
        this.updateProject(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Project Updated Successfully");
            this.$emit("projectCreated");
            this.editTitle ="Unnamed Project"
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      } else {
        this.createProject(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Project Created Successfully");
            this.$emit("projectCreated");
            this.editTitle ="Unnamed Project"
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      }
    }
  }
};
</script>

<style scoped>
 .card-header {
   padding: 0.8rem 1.5rem;
 }
 .task-title {
      color: #ffffff;
    font-family: Gotham-Bold;
  
    display: block;
    min-width: 100%;
    padding: 10px 0;
    height: 40px;
     outline: none;
    box-shadow: none;
    cursor: text;
        border-bottom: 1px rgba(255, 255, 255, 0) dashed;
 }
 .task-title:focus,
 .task-title:focus-within{
      outline: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    cursor: text;
    border-bottom: 1px rgba(255, 255, 255, .4) dashed;
 }
 .brace {
    font-family:Gotham-Bold;
    color: #fddf43;
 }

</style>
 